import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
var THROTTLE_TIME = 100;
export var usePageScrollY = function () {
    var _a = useState(0), pageScrollY = _a[0], setPageScrollY = _a[1];
    useEffect(function () {
        var handleScroll = debounce(function () {
            // This avoids mobile devices having the ability to swipe up under 0.
            setPageScrollY(window.scrollY < 0 ? 0 : window.scrollY);
        }, THROTTLE_TIME, { leading: true });
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return {
        pageScrollY: pageScrollY,
    };
};
